export default "__VITE_ASSET__3Yl4w1Gx__"